import React from 'react';

const AsyncCorpusMonitor = React.lazy(() => import('./CorpusMonitorContainer'));
export const CorpusMonitorPage = () => {
  return <AsyncCorpusMonitor />;
};
